import { colors } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import type { KeyboardEventHandler, Ref } from "react";

export function SearchFieldInput({
  inputRef,
  query,
  onQueryChange,
  onKeyDown,
  onClear,
}: Readonly<{
  inputRef: Ref<HTMLInputElement>;
  query: string;
  onQueryChange(value: string): void;
  onKeyDown: KeyboardEventHandler<HTMLInputElement>;
  onClear(): void;
}>) {
  return (
    <>
      <input
        ref={inputRef}
        type="text"
        value={query}
        onChange={(event) => onQueryChange(event.target.value)}
        onKeyDown={onKeyDown}
        placeholder="Search"
        aria-label="Search"
        {...stylex.props(styles.input)}
      />
      <button
        type="button"
        aria-label="Clear search"
        onClick={onClear}
        {...stylex.props(styles.clear)}
      >
        <svg width={12} height={12} viewBox="0 0 12 12" aria-hidden="true">
          <path
            d="M2 2 10 10M10 2 2 10"
            stroke="currentColor"
            strokeWidth={1.4}
            strokeLinecap="round"
          />
        </svg>
      </button>
    </>
  );
}

const styles = stylex.create({
  input: {
    minWidth: 0,
    flex: 1,
    borderWidth: 0,
    backgroundColor: "transparent",
    padding: 0,
    color: colors.foreground,
    fontFamily: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
    letterSpacing: "inherit",
    outline: "none",
    "::placeholder": { color: colors.muted },
  },
  clear: {
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    width: 16,
    height: 16,
    flexShrink: 0,
    padding: 0,
    borderWidth: 0,
    backgroundColor: "transparent",
    color: { default: colors.secondary, ":hover": colors.foreground },
    cursor: "pointer",
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.foreground}`,
    },
    outlineOffset: 3,
    "::after": {
      content: { default: "none", "@media (pointer: coarse)": '""' },
      position: "absolute",
      inset: -14,
    },
  },
});
